


export const GET_INNOVATE_IDEA_TEMPLATE_ID_JSON_STARTED = 'GET_INNOVATE_IDEA_TEMPLATE_ID_JSON_STARTED'
export const GET_INNOVATE_IDEA_TEMPLATE_ID_JSON_FAILURE = 'GET_INNOVATE_IDEA_TEMPLATE_ID_JSON_FAILURE'
export const GET_INNOVATE_IDEA_TEMPLATE_ID_JSON_SUCCESS = 'GET_INNOVATE_IDEA_TEMPLATE_ID_JSON_SUCCESS'

export const POST_INNOVATE_CREATE_IDEA_DRAFT_STARTED = 'POST_INNOVATE_CREATE_IDEA_DRAFT_STARTED'
export const POST_INNOVATE_CREATE_IDEA_DRAFT_FAILURE = 'POST_INNOVATE_CREATE_IDEA_DRAFT_FAILURE'
export const POST_INNOVATE_CREATE_IDEA_DRAFT_SUCCESS = 'POST_INNOVATE_CREATE_IDEA_DRAFT_SUCCESS'

export const POST_INNOVATE_CREATE_IDEA_PUBLISH_STARTED = 'POST_INNOVATE_CREATE_IDEA_PUBLISH_STARTED'
export const POST_INNOVATE_CREATE_IDEA_PUBLISH_FAILURE = 'POST_INNOVATE_CREATE_IDEA_PUBLISH_FAILURE'
export const POST_INNOVATE_CREATE_IDEA_PUBLISH_SUCCESS = 'POST_INNOVATE_CREATE_IDEA_PUBLISH_SUCCESS'

export const POST_INNOVATE_CREATE_IDEA_EDIT_STARTED = 'POST_INNOVATE_CREATE_IDEA_EDIT_STARTED'
export const POST_INNOVATE_CREATE_IDEA_EDIT_FAILURE = 'POST_INNOVATE_CREATE_IDEA_EDIT_FAILURE'
export const POST_INNOVATE_CREATE_IDEA_EDIT_SUCCESS = 'POST_INNOVATE_CREATE_IDEA_EDIT_SUCCESS'

export const GET_ID_INNOVATE_INITIAL_IDEA_DRAFT_STARTED = 'GET_ID_INNOVATE_INITIAL_IDEA_DRAFT_STARTED'
export const GET_ID_INNOVATE_INITIAL_IDEA_DRAFT_FAILURE = 'GET_ID_INNOVATE_INITIAL_IDEA_DRAFT_FAILURE'
export const GET_ID_INNOVATE_INITIAL_IDEA_DRAFT_SUCCESS = 'GET_ID_INNOVATE_INITIAL_IDEA_DRAFT_SUCCESS'

export const UPLOAD_INNOVATE_IDEA_DOCUMENT_STARTED = 'UPLOAD_INNOVATE_IDEA_DOCUMENT_STARTED'
export const UPLOAD_INNOVATE_IDEA_DOCUMENT_FAILURE = 'UPLOAD_INNOVATE_IDEA_DOCUMENT_FAILURE'
export const UPLOAD_INNOVATE_IDEA_DOCUMENT_SUCCESS = 'UPLOAD_INNOVATE_IDEA_DOCUMENT_SUCCESS'

export const DELETE_INNOVATE_IDEA_DOCUMENT_STARTED = 'DELETE_INNOVATE_IDEA_DOCUMENT_STARTED'
export const DELETE_INNOVATE_IDEA_DOCUMENT_FAILURE = 'DELETE_INNOVATE_IDEA_DOCUMENT_FAILURE'
export const DELETE_INNOVATE_IDEA_DOCUMENT_SUCCESS = 'DELETE_INNOVATE_IDEA_DOCUMENT_SUCCESS'

export const DELETE_IMAGE_INNOVATE_CREATE_IDEA_STARTED = 'DELETE_IMAGE_INNOVATE_CREATE_IDEA_STARTED' 
export const DELETE_IMAGE_INNOVATE_CREATE_IDEA_FAILURE = 'DELETE_IMAGE_INNOVATE_CREATE_IDEA_FAILURE' 
export const DELETE_IMAGE_INNOVATE_CREATE_IDEA_SUCCESS = 'DELETE_IMAGE_INNOVATE_CREATE_IDEA_SUCCESS' 

export const ADD_IMAGE_INNOVATE_CREATE_IDEA_STARTED = 'ADD_IMAGE_INNOVATE_CREATE_IDEA_STARTED' 
export const ADD_IMAGE_INNOVATE_CREATE_IDEA_FAILURE = 'ADD_IMAGE_INNOVATE_CREATE_IDEA_FAILURE' 
export const ADD_IMAGE_INNOVATE_CREATE_IDEA_SUCCESS = 'ADD_IMAGE_INNOVATE_CREATE_IDEA_SUCCESS' 


export const GET_IDEA_ID_DETAILS_INNOVATE_STARTED = 'GET_IDEA_ID_DETAILS_INNOVATE_STARTED' 
export const GET_IDEA_ID_DETAILS_INNOVATE_FAILURE = 'GET_IDEA_ID_DETAILS_INNOVATE_FAILURE' 
export const GET_IDEA_ID_DETAILS_INNOVATE_SUCCESS = 'GET_IDEA_ID_DETAILS_INNOVATE_SUCCESS' 

export const DELETE_INNOVATE_IDEA_BY_ID_STARTED = 'DELETE_INNOVATE_IDEA_BY_ID_STARTED' 
export const DELETE_INNOVATE_IDEA_BY_ID_SUCCESS = 'DELETE_INNOVATE_IDEA_BY_ID_SUCCESS' 
export const DELETE_INNOVATE_IDEA_BY_ID_FAILURE = 'DELETE_INNOVATE_IDEA_BY_ID_FAILURE' 

export const GET_USER_EVALUATOR_SEARCH_INNOVATE_STARTED = 'GET_USER_EVALUATOR_SEARCH_INNOVATE_STARTED' 
export const GET_USER_EVALUATOR_SEARCH_INNOVATE_SUCCESS = 'GET_USER_EVALUATOR_SEARCH_INNOVATE_SUCCESS' 
export const GET_USER_EVALUATOR_SEARCH_INNOVATE_FAILURE = 'GET_USER_EVALUATOR_SEARCH_INNOVATE_FAILURE' 

export const ADD_USER_EVALUATOR_INNOVATE_IDEA_STARTED = 'ADD_USER_EVALUATOR_INNOVATE_IDEA_STARTED' 
export const ADD_USER_EVALUATOR_INNOVATE_IDEA_SUCCESS = 'ADD_USER_EVALUATOR_INNOVATE_IDEA_SUCCESS' 
export const ADD_USER_EVALUATOR_INNOVATE_IDEA_FAILURE = 'ADD_USER_EVALUATOR_INNOVATE_IDEA_FAILURE' 

export const GET_JSON_CHALLENGE_TEMPLATE_ID_INNOVATE_STARTED = 'GET_JSON_CHALLENGE_TEMPLATE_ID_INNOVATE_STARTED'
export const GET_JSON_CHALLENGE_TEMPLATE_ID_INNOVATE_SUCCESS = 'GET_JSON_CHALLENGE_TEMPLATE_ID_INNOVATE_SUCCESS'
export const GET_JSON_CHALLENGE_TEMPLATE_ID_INNOVATE_FAILURE = 'GET_JSON_CHALLENGE_TEMPLATE_ID_INNOVATE_FAILURE'


export const GET_LIST_EVALUATOR_ASSIGNED_INNOVATE_STARTED = 'GET_LIST_EVALUATOR_ASSIGNED_INNOVATE_STARTED'
export const GET_LIST_EVALUATOR_ASSIGNED_INNOVATE_SUCCESS = 'GET_LIST_EVALUATOR_ASSIGNED_INNOVATE_SUCCESS'
export const GET_LIST_EVALUATOR_ASSIGNED_INNOVATE_FAILURE = 'GET_LIST_EVALUATOR_ASSIGNED_INNOVATE_FAILURE'

export const  DELETE_IDEA_ASSIGNED_EVALUATOR_STARTED = 'DELETE_IDEA_ASSIGNED_EVALUATOR_STARTED'
export const  DELETE_IDEA_ASSIGNED_EVALUATOR_SUCCESS = 'DELETE_IDEA_ASSIGNED_EVALUATOR_SUCCESS'
export const  DELETE_IDEA_ASSIGNED_EVALUATOR_FAILURE = 'DELETE_IDEA_ASSIGNED_EVALUATOR_FAILURE'

export const  GET_JSON_EVALUATOR_RATED_INNOVATE_FAILURE = 'GET_JSON_EVALUATOR_RATED_INNOVATE_FAILURE'
export const  GET_JSON_EVALUATOR_RATED_INNOVATE_SUCCESS = 'GET_JSON_EVALUATOR_RATED_INNOVATE_SUCCESS'
export const  GET_JSON_EVALUATOR_RATED_INNOVATE_STARTED = 'GET_JSON_EVALUATOR_RATED_INNOVATE_STARTED'

export const  GET_EVALUATION_DASHBOARD_INNOVATE_IDEA_STARTED = 'GET_EVALUATION_DASHBOARD_INNOVATE_IDEA_STARTED'
export const  GET_EVALUATION_DASHBOARD_INNOVATE_IDEA_SUCCESS = 'GET_EVALUATION_DASHBOARD_INNOVATE_IDEA_SUCCESS'
export const  GET_EVALUATION_DASHBOARD_INNOVATE_IDEA_FAILURE = 'GET_EVALUATION_DASHBOARD_INNOVATE_IDEA_FAILURE'

export const  GET_MYEVALUATION_DASHBOARD_INNOVATE_IDEA_STARTED = 'GET_MYEVALUATION_DASHBOARD_INNOVATE_IDEA_STARTED'
export const  GET_MYEVALUATION_DASHBOARD_INNOVATE_IDEA_SUCCESS = 'GET_MYEVALUATION_DASHBOARD_INNOVATE_IDEA_SUCCESS'
export const  GET_MYEVALUATION_DASHBOARD_INNOVATE_IDEA_FAILURE = 'GET_MYEVALUATION_DASHBOARD_INNOVATE_IDEA_FAILURE'

export const PUT_RATING_SUBMIT_EVALUATOR_INNOVATE_IDEA_STARTED = 'PUT_RATING_SUBMIT_EVALUATOR_INNOVATE_IDEA_STARTED'
export const PUT_RATING_SUBMIT_EVALUATOR_INNOVATE_IDEA_SUCCESS = 'PUT_RATING_SUBMIT_EVALUATOR_INNOVATE_IDEA_SUCCESS'
export const PUT_RATING_SUBMIT_EVALUATOR_INNOVATE_IDEA_FAILURE = 'PUT_RATING_SUBMIT_EVALUATOR_INNOVATE_IDEA_FAILURE'

export const PUT_RATING_EDIT_EVALUATOR_INNOVATE_IDEA_STARTED = 'PUT_RATING_EDIT_EVALUATOR_INNOVATE_IDEA_STARTED'
export const PUT_RATING_EDIT_EVALUATOR_INNOVATE_IDEA_SUCCESS = 'PUT_RATING_EDIT_EVALUATOR_INNOVATE_IDEA_SUCCESS'
export const PUT_RATING_EDIT_EVALUATOR_INNOVATE_IDEA_FAILURE = 'PUT_RATING_EDIT_EVALUATOR_INNOVATE_IDEA_FAILURE'

export const POST_RATING_SAVE_EVALUATOR_INNOVATE_IDEA_STARTED = 'POST_RATING_SAVE_EVALUATOR_INNOVATE_IDEA_STARTED'
export const POST_RATING_SAVE_EVALUATOR_INNOVATE_IDEA_SUCCESS = 'POST_RATING_SAVE_EVALUATOR_INNOVATE_IDEA_SUCCESS'
export const POST_RATING_SAVE_EVALUATOR_INNOVATE_IDEA_FAILURE = 'POST_RATING_SAVE_EVALUATOR_INNOVATE_IDEA_FAILURE'

export const POST_INNOVATE_IDEA_APPROVE_STARTED = 'POST_INNOVATE_IDEA_APPROVE_STARTED'
export const POST_INNOVATE_IDEA_APPROVE_SUCCESS = 'POST_INNOVATE_IDEA_APPROVE_SUCCESS'
export const POST_INNOVATE_IDEA_APPROVE_FAILURE = 'POST_INNOVATE_IDEA_APPROVE_FAILURE'

export const GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_STARTED = 'GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_STARTED'
export const GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_SUCCESS = 'GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_SUCCESS'
export const GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_FAILURE = 'GET_IF_HACKTHON_TRUE_INNOVATE_IDEA_FAILURE'

export const GET_INNOVATE_MY_IDEA_STARTED = 'GET_INNOVATE_MY_IDEA_STARTED'
export const GET_INNOVATE_MY_IDEA_SUCCESS = 'GET_INNOVATE_MY_IDEA_SUCCESS'
export const GET_INNOVATE_MY_IDEA_FAILURE = 'GET_INNOVATE_MY_IDEA_FAILURE'

export const GET_INNOVATE_IDEA_TEAM_STARTED = 'GET_INNOVATE_IDEA_TEAM_STARTED'
export const GET_INNOVATE_IDEA_TEAM_SUCCESS = 'GET_INNOVATE_IDEA_TEAM_SUCCESS'
export const GET_INNOVATE_IDEA_TEAM_FAILURE = 'GET_INNOVATE_IDEA_TEAM_FAILURE'

export const GET_VALIDATE_SCORECARD_USER_URL_INNOVATE_STARTED = 'GET_VALIDATE_SCORECARD_USER_URL_INNOVATE_STARTED'
export const GET_VALIDATE_SCORECARD_USER_URL_INNOVATE_SUCCESS = 'GET_VALIDATE_SCORECARD_USER_URL_INNOVATE_SUCCESS'
export const GET_VALIDATE_SCORECARD_USER_URL_INNOVATE_FAILURE = 'GET_VALIDATE_SCORECARD_USER_URL_INNOVATE_FAILURE'

export const ADD_TEAM_MEMBER_INNOVATE_IDEA_STARTED = 'ADD_TEAM_MEMBER_INNOVATE_IDEA_STARTED'
export const ADD_TEAM_MEMBER_INNOVATE_IDEA_SUCCESS = 'ADD_TEAM_MEMBER_INNOVATE_IDEA_SUCCESS'
export const ADD_TEAM_MEMBER_INNOVATE_IDEA_FAILURE = 'ADD_TEAM_MEMBER_INNOVATE_IDEA_FAILURE'

export const INVITE_TEAM_MEMBER_INNOVATE_IDEA_STARTED = 'INVITE_TEAM_MEMBER_INNOVATE_IDEA_STARTED'
export const INVITE_TEAM_MEMBER_INNOVATE_IDEA_SUCCESS = 'INVITE_TEAM_MEMBER_INNOVATE_IDEA_SUCCESS'
export const INVITE_TEAM_MEMBER_INNOVATE_IDEA_FAILURE = 'INVITE_TEAM_MEMBER_INNOVATE_IDEA_FAILURE'

export const PUT_INNOVATE_BUSINESS_SCORECARD_ADD_STARTED = 'PUT_INNOVATE_BUSINESS_SCORECARD_ADD_STARTED'
export const PUT_INNOVATE_BUSINESS_SCORECARD_ADD_SUCCESS = 'PUT_INNOVATE_BUSINESS_SCORECARD_ADD_SUCCESS'
export const PUT_INNOVATE_BUSINESS_SCORECARD_ADD_FAILURE = 'PUT_INNOVATE_BUSINESS_SCORECARD_ADD_FAILURE'

export const GET_USER_EVALUATOR_SEARCH_BY_COMMUNITY_INNOVATE_STARTED = 'GET_USER_EVALUATOR_SEARCH_BY_COMMUNITY_INNOVATE_STARTED'
export const GET_USER_EVALUATOR_SEARCH_BY_COMMUNITY_INNOVATE_SUCCESS = 'GET_USER_EVALUATOR_SEARCH_BY_COMMUNITY_INNOVATE_SUCCESS'
export const GET_USER_EVALUATOR_SEARCH_BY_COMMUNITY_INNOVATE_FAILURE = 'GET_USER_EVALUATOR_SEARCH_BY_COMMUNITY_INNOVATE_FAILURE'

export const ADD_SEARCH_BY_COMMUNITY_USER_EVALUATOR_INNOVATE_IDEA_STARTED = 'ADD_SEARCH_BY_COMMUNITY_USER_EVALUATOR_INNOVATE_IDEA_STARTED'
export const ADD_SEARCH_BY_COMMUNITY_USER_EVALUATOR_INNOVATE_IDEA_SUCCESS = 'ADD_SEARCH_BY_COMMUNITY_USER_EVALUATOR_INNOVATE_IDEA_SUCCESS'
export const ADD_SEARCH_BY_COMMUNITY_USER_EVALUATOR_INNOVATE_IDEA_FAILURE = 'ADD_SEARCH_BY_COMMUNITY_USER_EVALUATOR_INNOVATE_IDEA_FAILURE'

export const GET_SHOWPOPUP_EVALUATOR_ASSIGNED_INNOVATE_STARTED = 'GET_SHOWPOPUP_EVALUATOR_ASSIGNED_INNOVATE_STARTED'
export const GET_SHOWPOPUP_EVALUATOR_ASSIGNED_INNOVATE_SUCCESS = 'GET_SHOWPOPUP_EVALUATOR_ASSIGNED_INNOVATE_SUCCESS'
export const GET_SHOWPOPUP_EVALUATOR_ASSIGNED_INNOVATE_FAILURE = 'GET_SHOWPOPUP_EVALUATOR_ASSIGNED_INNOVATE_FAILURE'


export const INNOVATE_DELETE_USER_FROM_TEAM_STARTED = 'INNOVATE_DELETE_USER_FROM_TEAM_STARTED'
export const INNOVATE_DELETE_USER_FROM_TEAM_SUCCESS = 'INNOVATE_DELETE_USER_FROM_TEAM_SUCCESS'
export const INNOVATE_DELETE_USER_FROM_TEAM_FAILURE = 'INNOVATE_DELETE_USER_FROM_TEAM_FAILURE'

// All Ideas page, filtered / paged ideaList calls. Results live in the page's own state, not in Redux.
export const GET_INNOVATE_ALL_IDEA_LIST_STARTED = 'GET_INNOVATE_ALL_IDEA_LIST_STARTED'
export const GET_INNOVATE_ALL_IDEA_LIST_SUCCESS = 'GET_INNOVATE_ALL_IDEA_LIST_SUCCESS'
export const GET_INNOVATE_ALL_IDEA_LIST_FAILURE = 'GET_INNOVATE_ALL_IDEA_LIST_FAILURE'

export const GET_INNOVATE_IDEA_WITH_STATUS_STARTED = 'GET_INNOVATE_IDEA_WITH_STATUS_STARTED'
export const GET_INNOVATE_IDEA_WITH_STATUS_SUCCESS = 'GET_INNOVATE_IDEA_WITH_STATUS_SUCCESS'
export const GET_INNOVATE_IDEA_WITH_STATUS_FAILURE = 'GET_INNOVATE_IDEA_WITH_STATUS_FAILURE'

export const GET_IDEA_HISTORY_INNOVATE_STARTED = 'GET_IDEA_HISTORY_INNOVATE_STARTED'
export const GET_IDEA_HISTORY_INNOVATE_SUCCESS = 'GET_IDEA_HISTORY_INNOVATE_SUCCESS'
export const GET_IDEA_HISTORY_INNOVATE_FAILURE = 'GET_IDEA_HISTORY_INNOVATE_FAILURE'

export const MOVE_TO_DRAFT_INNOVATE_STARTED = 'MOVE_TO_DRAFT_INNOVATE_STARTED'
export const MOVE_TO_DRAFT_INNOVATE_SUCCESS = 'MOVE_TO_DRAFT_INNOVATE_SUCCESS'
export const MOVE_TO_DRAFT_INNOVATE_FAILURE = 'MOVE_TO_DRAFT_INNOVATE_FAILURE'


export const INNOVATE_GET_CHALLENGE_TAGGED_IDEA_LIST_STARTED = 'INNOVATE_GET_CHALLENGE_TAGGED_IDEA_LIST_STARTED'
export const INNOVATE_GET_CHALLENGE_TAGGED_IDEA_LIST_SUCCESS = 'INNOVATE_GET_CHALLENGE_TAGGED_IDEA_LIST_SUCCESS'
export const INNOVATE_GET_CHALLENGE_TAGGED_IDEA_LIST_FAILURE = 'INNOVATE_GET_CHALLENGE_TAGGED_IDEA_LIST_FAILURE'

export const ADD_BULK_SME_USER_EVALUATOR_INNOVATE_IDEA_STARTED = 'ADD_BULK_SME_USER_EVALUATOR_INNOVATE_IDEA_STARTED'
export const ADD_BULK_SME_USER_EVALUATOR_INNOVATE_IDEA_FAILURE = 'ADD_BULK_SME_USER_EVALUATOR_INNOVATE_IDEA_FAILURE'
export const ADD_BULK_SME_USER_EVALUATOR_INNOVATE_IDEA_SUCCESS = 'ADD_BULK_SME_USER_EVALUATOR_INNOVATE_IDEA_SUCCESS'

export const REMOVE_SELECTED_SME_USER_FROM_ALL_TAG_IDEA_WITH_THIS_CHALLENGE_STARTED = 'REMOVE_SELECTED_SME_USER_FROM_ALL_TAG_IDEA_WITH_THIS_CHALLENGE_STARTED'
export const REMOVE_SELECTED_SME_USER_FROM_ALL_TAG_IDEA_WITH_THIS_CHALLENGE_SUCCESS = 'REMOVE_SELECTED_SME_USER_FROM_ALL_TAG_IDEA_WITH_THIS_CHALLENGE_SUCCESS'
export const REMOVE_SELECTED_SME_USER_FROM_ALL_TAG_IDEA_WITH_THIS_CHALLENGE_FAILURE = 'REMOVE_SELECTED_SME_USER_FROM_ALL_TAG_IDEA_WITH_THIS_CHALLENGE_FAILURE'

export const GET_MYEVALUATION_DASHBOARD_IDEA_HISTORY_STARTED = 'GET_MYEVALUATION_DASHBOARD_IDEA_HISTORY_STARTED'
export const GET_MYEVALUATION_DASHBOARD_IDEA_HISTORY_SUCCESS = 'GET_MYEVALUATION_DASHBOARD_IDEA_HISTORY_SUCCESS'
export const GET_MYEVALUATION_DASHBOARD_IDEA_HISTORY_FAILURE = 'GET_MYEVALUATION_DASHBOARD_IDEA_HISTORY_FAILURE'
